import PageShell from '@/pages/shared/PageShell';

export default function Terms() {
  return (
    <PageShell
      title="利用規約｜”おもいむすび”"
      description="”おもいむすび”の利用規約。本サービスの利用に関する条件を定めています。"
      canonical="https://omoimusubi.asia/terms/"
      h1="利用規約"
      showCTA={false}
      relatedLinks={[
        { label: 'プライバシーポリシー', path: '/privacy/' },
        { label: '特定商取引法に基づく表記', path: '/commercial-law/' },
      ]}
    >
      <section>
        <h2>第1条（適用）</h2>
        <p>本規約は、株式会社cafoot（以下「当社」）が提供する「”おもいむすび”」（以下「本サービス」）の利用に関する条件を定めるものです。</p>
      </section>
      <section>
        <h2>第2条（利用登録）</h2>
        <p>本サービスの利用を希望する者は、当社所定の方法により利用登録を申請し、当社がこれを承認することにより利用登録が完了します。</p>
      </section>
      <section>
        <h2>第3条（利用料金）</h2>
        <p>本サービスの利用料金は、当社が別途定める料金表に基づきます。利用料金はすべて税別です。</p>
      </section>
      <section>
        <h2>第4条（禁止事項）</h2>
        <p>利用者は、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>当社または第三者の知的財産権を侵害する行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>その他、当社が不適切と判断する行為</li>
        </ul>
      </section>
      <p className="text-sm text-foreground-500 mt-10">※ 本利用規約は仮のものです。正式なサービス提供時には、弁護士監修のもと適切な内容に更新されます。</p>
    </PageShell>
  );
}